module.exports = __webpack_public_path__ + "src/assets/games/42/18.jpg";